import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserAutoLoginActionTokenMutationVariables = Types.Exact<{
  xTenantId: Types.Scalars['ID']['input'];
  userAutoLoginActionTokenInput: Types.UserAutoLoginActionTokenInput;
}>;


export type UserAutoLoginActionTokenMutation = { __typename?: 'Mutation', userAutoLoginActionToken: { __typename?: 'UserAutoLoginActionTokenResponse', data?: string | null } };


export const UserAutoLoginActionTokenDocument = gql`
    mutation UserAutoLoginActionToken($xTenantId: ID!, $userAutoLoginActionTokenInput: UserAutoLoginActionTokenInput!) {
  userAutoLoginActionToken(
    xTenantID: $xTenantId
    userAutoLoginActionTokenInput: $userAutoLoginActionTokenInput
  ) {
    data
  }
}
    `;
export type UserAutoLoginActionTokenMutationFn = Apollo.MutationFunction<UserAutoLoginActionTokenMutation, UserAutoLoginActionTokenMutationVariables>;

/**
 * __useUserAutoLoginActionTokenMutation__
 *
 * To run a mutation, you first call `useUserAutoLoginActionTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAutoLoginActionTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAutoLoginActionTokenMutation, { data, loading, error }] = useUserAutoLoginActionTokenMutation({
 *   variables: {
 *      xTenantId: // value for 'xTenantId'
 *      userAutoLoginActionTokenInput: // value for 'userAutoLoginActionTokenInput'
 *   },
 * });
 */
export function useUserAutoLoginActionTokenMutation(baseOptions?: Apollo.MutationHookOptions<UserAutoLoginActionTokenMutation, UserAutoLoginActionTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAutoLoginActionTokenMutation, UserAutoLoginActionTokenMutationVariables>(UserAutoLoginActionTokenDocument, options);
      }
export type UserAutoLoginActionTokenMutationHookResult = ReturnType<typeof useUserAutoLoginActionTokenMutation>;
export type UserAutoLoginActionTokenMutationResult = Apollo.MutationResult<UserAutoLoginActionTokenMutation>;
export type UserAutoLoginActionTokenMutationOptions = Apollo.BaseMutationOptions<UserAutoLoginActionTokenMutation, UserAutoLoginActionTokenMutationVariables>;